var React = require('react');
var selectableData = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableData.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var apiDataRepository = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableApiData.jsx');

const memberAppFuncs = {
    districtCount: function (chosenPrimaryPracticeLocation) {
        let dCnt = 0;
        if (selectableData["districts"] && selectableData["districts"].length && chosenPrimaryPracticeLocation) {
            var districtCodes = selectableData["districts"].map(x => ({
                distictCode: x.Code,
                districtDesc: x.DistrictDescription,
                districtStatecode: x.StateCode ? x.StateCode.toUpperCase() : ''
            }));

            let uniqueDistictCodes = [];
            districtCodes.map(x => uniqueDistictCodes.filter(a => a.distictCode == x.distictCode && a.districtDesc == x.districtDesc && a.districtStatecode == x.districtStatecode).length > 0 ? null : uniqueDistictCodes.push(x));

            let districtlistfilterbyPPL = uniqueDistictCodes.filter(function (districtlist) {
                return districtlist.districtStatecode == chosenPrimaryPracticeLocation
            });

            dCnt = districtlistfilterbyPPL.length;
        }

        return dCnt;
    }
}

module.exports = memberAppFuncs;